var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-66e30694-aec5-4eb8-a054-8b33b859100c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m8.542,12.758c.16-.371.353-.723.564-1.062l.785,3.978,9.684-8.466L7.402,3.052l.958,4.857c-1.093,1.025-1.97,2.268-2.571,3.659-1.65,3.815-1.128,7.792,1.467,11.199.295.387.742.591,1.194.591.317,0,.636-.1.908-.307.659-.502.786-1.443.284-2.102-2.447-3.211-1.949-6.226-1.1-8.19Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.211,20.432c1.65-3.815,1.128-7.792-1.467-11.199-.502-.659-1.444-.786-2.102-.284-.659.502-.786,1.443-.284,2.102,2.447,3.211,1.949,6.226,1.1,8.19-.16.371-.353.723-.564,1.062l-.785-3.978-9.684,8.466,12.174,4.155-.958-4.857c1.093-1.025,1.97-2.268,2.571-3.659Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.f4a053376745829325fcb9011d72feb2.svg";
export { ForwardRef as ReactComponent };